import React, { useState, useEffect } from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { fakeJson } from './fakeJson.js';
import { fakeJsonV2 } from './fakeJsonV2.js';

export const StrategiesContextV2 = React.createContext({});

const StrategiesContextProvider = (props) => {
  const [strategies, setStrategies] = useState();
  const [actualStrategy, setActualStrategy] = useState();
  const [actualVehicle, setActualVehicle] = useState();

  const { strategyName, vehicleName, children } = props;

  const isProductTypeComposite = (data) => {
    const productType = get(data, 'share_class.product_type.value', '');
    return productType.toLowerCase() === 'composite';
  };

  const idPage = document.body.className.split('page-id-')[1];
  const id = idPage ? parseInt(idPage) : null;

  useEffect(() => {
    const currentPath = window.location.pathname;
    const matchingSubsite = ['institutional', 'individual', 'financial-advisor'].find(subsite =>
      currentPath.includes(subsite)
    );
    const endpointURL =
      document.getElementById('root').dataset.url ||
      // `https://wp-jensen-replatform-prd-clone-aywpb.statik.space/${matchingSubsite || ''}/wp-json/jensen/v3/etf-vehicles?page_id=${id}`;
      // `https://wp-jensen-replatform-stg-aywpb.statik.space/${matchingSubsite || ''}/wp-json/jensen/v3/etf-vehicles?page_id=${id}`;
      `https://www.jenseninvestment.com/${matchingSubsite || ''}/wp-json/jensen/v3/etf-vehicles?page_id=${id}`;
      // 'https://wp-jensen-replatform-stg-aywpb.statik.space/wp-json/jensen/v2/strategies';
      // 'https://www.jenseninvestment.com/wp-json/jensen/v2/strategies';
    axios
      .request({
        url: endpointURL,
        crossDomain: true,
      })
      .then((response) => {
        setStrategies(response.data);
        // setStrategies(fakeJson.content);
        // setStrategies(fakeJsonV2.content);
        })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (strategies) {
      const actualStrategyObj = strategies.find(
        (strategy) => strategy.name === strategyName
      );

      setActualStrategy(actualStrategyObj);
    }
  }, [strategies, strategyName]);

  useEffect(() => {
    if (actualStrategy) {
      const actualVehicleObj = actualStrategy.funds.find(
        (vehicle) => vehicle.clientCode === vehicleName
      );
      setActualVehicle({
        ...actualVehicleObj,
        isCompositeProduct: isProductTypeComposite(actualVehicleObj),
      });
    }
  }, [actualStrategy, vehicleName]);

  const value = {
    strategies,
    actualStrategy,
    actualVehicle,
  };

  return (
    <StrategiesContextV2.Provider value={value}>
      {children}
    </StrategiesContextV2.Provider>
  );
};

export default StrategiesContextProvider;
